/** Saudação honesta por turno (D6) — derivada da hora local, sem cenário fake. */
export function deriveGreeting(nowMs, firstName) {
    const hour = new Date(nowMs).getHours();
    const greeting = hour < 12 ? 'Bom dia' : hour < 18 ? 'Boa tarde' : 'Boa noite';
    return firstName.length > 0 ? `${greeting}, ${firstName}` : greeting;
}
//# sourceMappingURL=greeting.js.map